<template>
  <div class="sidebar__section sidebar__section--bottom">
    <div class="sidebar__foot">
      <!-- Origem Flow: rodapé estilo ClickUp ("Personalizar a barra lateral");
           o clique recolhe/expande a sidebar. -->
      <a
        class="sidebar__customize"
        @click="$emit('set-col1-width', collapsed ? 240 : 52)"
      >
        <i class="sidebar__customize-icon iconoir-settings"></i>
        <span v-show="!collapsed" class="sidebar__customize-text">{{
          $t('sidebar.customizeSidebar')
        }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarFoot',
  props: {
    collapsed: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    width: {
      type: Number,
      required: true,
    },
  },
  emits: ['set-col1-width'],
}
</script>
